<template>
    <div>

        <div class="layui-card-header">
            <blockquote class="layui-elem-quote">
                认定记录
            </blockquote>
        </div>

        <div class="layui-card-body">
            <el-tabs type="border-card" style="margin-top: 10px;">
                <el-tab-pane label="当前申报">
                    <el-table :data="tableData" style="width: 100%">
                        <!-- 序号 -->
                        <el-table-column align="center" label="序号" width="50" type="index">
                        </el-table-column>

                        <!-- 申报工种  -->
                        <el-table-column align="center" label="申报工种" width="100" prop="workTypeAlias">
                        </el-table-column>

                        <!-- 报名状态 -->
                        <el-table-column align="center" label="报名状态" width="100">
                            <template slot-scope="scope">
                                <span v-if="scope.row.registrationreStatus == 1" style="color: green;">正常</span>
                                <span v-if="scope.row.registrationreStatus == 2" style="color: red;">预报名</span>
                            </template>
                        </el-table-column>

                        <!-- 申报等级  -->
                        <el-table-column align="center" label="申报等级" width="180" prop="workTypeLevelStateDesc">
                        </el-table-column>

                        <!-- 申报状态 -->
                        <el-table-column align="center" label="申报状态" width="120">
                            <template slot-scope="scope">
                                <span v-if="scope.row.declareStatus == 1" style="color: red;">尚未提交审核！</span>
                                <span v-if="scope.row.declareStatus == 2" style="color: green;">待审核</span>
                            </template>
                        </el-table-column>

                        <!-- 申报时间  -->
                        <el-table-column align="center" label="申报时间" width="180" prop="declareTime">
                        </el-table-column>


                        <!-- 审核状态 -->
                        <el-table-column label="审核状态" width="150" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.declareStatus == 1" style="color: red;">尚未提交审核！</span>
                                <span v-else="scope.row.examineStatus == 1" style="color: #49af4a;">审核中...</span>
                            </template>
                        </el-table-column>


                        <el-table-column label="操作" fixed="right" width="300" align="center">
                            <template slot-scope="scope">

                                <el-button size="mini" type="primary" @click="affirmDetails(scope.row)">详情</el-button>

                                <el-button v-if="scope.row.declareStatus == 1 && scope.row.examineStatus == 1"
                                    size="mini" type="success" @click="submitAudit(scope.row)">提交审核</el-button>

                                <el-button v-if="scope.row.examineStatus == 1" size="mini" type="danger"
                                    @click="affirmCancel(scope.row)">取消</el-button>

                                <el-button v-if="scope.row.examineStatus == 2" size="mini" type="primary">导出</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="历史申报">
                    <el-table :data="tableDataHistory" style="width: 100%">
                        <!-- 序号 -->
                        <el-table-column label="序号" width="50" type="index" align="center">
                        </el-table-column>

                        <!-- 申报工种  -->
                        <el-table-column label="申报工种" width="100" prop="workTypeAlias" show-overflow-tooltip
                            align="center">
                        </el-table-column>

                        <!-- 报名状态 -->
                        <el-table-column label="报名状态" width="100" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.registrationreStatus == 1" style="color: green;">正常</span>
                                <span v-if="scope.row.registrationreStatus == 2" style="color: red;">预报名</span>
                            </template>
                        </el-table-column>

                        <!-- 申报等级  -->
                        <el-table-column label="申报等级" width="180" prop="workTypeLevelStateDesc" align="center">
                        </el-table-column>

                        <!-- 申报时间  -->
                        <el-table-column label="申报时间" width="180" prop="declareTime" align="center">
                        </el-table-column>

                        <!-- 审核状态 -->
                        <el-table-column label="审核状态" width="150" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.examineStatus == 1" style="color: #00aeef;">审核中</span>
                                <span v-if="scope.row.examineStatus == 2" style="color: #49af4a;">通过</span>
                                <span v-if="scope.row.examineStatus == 3" style="color: red;">未通过</span>
                            </template>
                        </el-table-column>


                        <el-table-column label="操作" fixed="right" width="250" align="center">
                            <template slot-scope="scope">

                                <el-button size="mini" type="primary" @click="affirmDetails(scope.row)">详情</el-button>

                                <el-button v-if="scope.row.declareStatus == 1 && scope.row.examineStatus == 1"
                                    size="mini" type="success" @click="submitAudit(scope.row)">提交审核</el-button>

                                <el-button v-if="scope.row.examineStatus == 1" size="mini" type="danger"
                                    @click="affirmCancel(scope.row)">取消</el-button>

                                <el-button v-if="scope.row.examineStatus == 2" size="mini" type="primary"
                                    @click="exportDetail(scope.row)">导出</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>

            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px;">
            </el-pagination>

            <el-dialog title="申报信息详情" :visible.sync="dialogTableVisible2" :center="true" width="70%">

                <table class="layui-table" style="margin: 0 auto;">
                    <tbody>
                        <tr style="text-align: center;">
                            <td colspan="10" style="width: 450.00pt;
                                            text-align: center;
                                            font-size: 18px;
                                            font-weight: bold;">
                                职业技能等级认定
                            </td>
                        </tr>
                        <tr>
                            <td colspan="10" style="width: 450.00pt;
                                            color: black;
                                            font-size: 18px;font-weight: 600">
                                基础信息
                            </td>
                        </tr>
                        <tr style="height:28.00pt;">
                            <td style="height:28.00pt;">姓名</td>
                            <td colspan="1">
                                <el-input placeholder="请输入内容" v-model="userName" disabled>
                                </el-input>
                            </td>
                            <td>性别</td>
                            <td colspan="1">
                                <el-radio-group v-model="sex" disabled>
                                    <el-radio :label="1">男</el-radio>
                                    <el-radio :label="2">女</el-radio>
                                </el-radio-group>
                            </td>
                            <td>民族</td>
                            <td colspan="3">
                                <el-select v-model="nation" placeholder="请选择" :disabled="true">
                                    <el-option v-for="(item,index) in nationList" :key="index" :label="item"
                                        :value="item"> </el-option>
                                </el-select>
                            </td>
                            <td rowspan="3" style="text-align: center;">
                                <img class="profile-image" src="/jnrd/static-ueditor/1605321108881.jpg" alt="个人头像">
                                <input name="headPath" type="hidden" value="1605321108881.jpg">
                            </td>
                        </tr>
                        <tr style="height:28.00pt;">
                            <td colspan="1" style="height:28.00pt;">联系方式</td>
                            <td colspan="2">
                                <el-input placeholder="请输入内容" v-model="phoneNumber" disabled>
                                </el-input>
                            </td>
                            <td style="height:28.00pt;">身份证号</td>
                            <td colspan="4">
                                <el-input placeholder="请输入内容" v-model="idCard" disabled>
                                </el-input>
                            </td>

                        </tr>
                        <tr style="height:28.00pt;">
                            <td style="height:28.00pt;">文化程度</td>
                            <td colspan="2">
                                <el-select v-model="education" placeholder="请选择" disabled>
                                    <el-option v-for="(item,index) in educationList" :key="index" :label="item"
                                        :value="item"> </el-option>
                                </el-select>
                            </td>
                            <td colspan="1">政治面貌</td>
                            <td colspan="4">
                                <div class="layui-input-inline" style="width: 210px">
                                    <el-select v-model="politic_countenance" placeholder="请选择" disabled>
                                        <el-option v-for="(item,index) in politic_countenanceList" :key="index"
                                            :label="item" :value="item"> </el-option>
                                    </el-select>
                                </div>
                            </td>
                        </tr>
                        <tr style="height:28.00pt;">
                            <td colspan="1"><span style="color: red;">*</span>报名点所在地区</td>
                            <td colspan="2">
                                <el-select v-model="registrationPlace" placeholder="请选择" disabled>
                                    <el-option v-for="(item,index) in registrationPlaceList" :key="index"
                                        :label="item.name" :value="item.value"> </el-option>
                                </el-select>
                            </td>
                            <td style="height:28.00pt;"><span style="color: red;">*</span>考生来源</td>
                            <td colspan="6">
                                <div class="layui-form-item" style="margin-bottom: 0px;">
                                    <div class="layui-input-inline" style="width: 210px;margin-right: 14px;">
                                        <el-cascader disabled v-model="candidatesSource" :options="candidatesSourceList"
                                            :props="{ expandTrigger: 'hover' }">
                                        </el-cascader>
                                    </div>
                                </div>
                            </td>

                        </tr>
                        <tr>
                            <td>工作时间</td>
                            <td colspan="2">
                                <el-date-picker style="width:203px" v-model="professionTime" type="date"
                                    placeholder="选择日期" :picker-options="pickerOptions" disabled>
                                </el-date-picker>
                            </td>
                            <td colspan="1">原技术等级</td>
                            <td colspan="3">
                                <div class="layui-input-inline" style="width: 210px">
                                    <div class="layui-unselect layui-form-select">
                                        <el-select v-model="historyWorkTypeLevel" placeholder="请选择" disabled>
                                            <el-option v-for="(item,index) in historyWorkTypeLevelList" :key="index"
                                                :label="item.name" :value="item.value"> </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </td>
                            <td colspan="1"><span style="color: red;">*</span>从事本工种年限</td>
                            <td colspan="1">
                                <el-input placeholder="工种年限" v-model="professionYears" disabled>
                                </el-input>
                            </td>

                        </tr>
                        <tr style="height:15.90pt;">
                            <td style="height:30.30pt;">原职业(工种）</td>
                            <td colspan="2">
                                <el-select v-model="historyWorkTypeId" placeholder="请选择" disabled>
                                    <el-option v-for="(item,index) in historyWorkTypeIdList" :key="index"
                                        :label="item.name" :value="item.value"> </el-option>
                                </el-select>
                            </td>
                            <td colspan="1">原证书编号</td>
                            <td colspan="3">
                                <el-input style="width:203px" placeholder="请输入原证书编号" v-model="certificateNum" disabled>
                                </el-input>
                            </td>
                            <td style="height:30.30pt;">原证书取得(时间）</td>
                            <td colspan="1">
                                <el-date-picker style="width:140px" v-model="historyWorkTypeDate" type="date"
                                    placeholder="选择日期" :picker-options="pickerOptions" disabled>
                                </el-date-picker>

                            </td>
                        </tr>
                    </tbody>
                </table>

                <table class="layui-table" style="margin: 24px auto 0px; position: static;">
                    <tbody>
                        <tr>
                            <td colspan="10" style="width: 450.00pt;font-size: 18px;color: black;font-weight: 600">
                                申报信息
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <td style="height:22.00pt;"><span style="color: red;">*</span>当前认定职业</td>
                            <td colspan="2">
                                <el-select v-model="workTypeId" placeholder="请选择" disabled>
                                    <el-option v-for="(item,index) in historyWorkTypeIdList" :key="index"
                                        :label="item.name" :value="item.value"> </el-option>
                                </el-select>
                            </td>
                            <td style="height:28.00pt;"><span style="color: red;">*</span>鉴定分类</td>
                            <td colspan="3">
                                <el-select v-model="declareClassification" placeholder="请选择" disabled>
                                    <el-option v-for="(item,index) in declareClassificationList" :key="index"
                                        :label="item" :value="item"> </el-option>
                                </el-select>
                            </td>
                            <td colspan="1"><span style="color: red;">*</span>当前认定等级</td>
                            <td colspan="1">
                                <el-select v-model="workTypeLevelState" :disabled="true" placeholder="请选择"
                                    style="width: 140px;">
                                    <el-option v-for="(item,index) in historyWorkTypeLevelList" :key="index"
                                        :label="item.name" :value="item.value"> </el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <td>证书是否邮寄</td>
                            <td colspan="2">
                                <el-radio-group v-model="mailOrNot" disabled>
                                    <el-radio :label="2">是</el-radio>
                                    <el-radio :label="1">否</el-radio>
                                </el-radio-group>
                            </td>
                            <td colspan="1" style="height:28.00pt;">证书邮寄地址</td>
                            <td colspan="6">
                                <el-input placeholder="如需要邮寄，请填写邮寄地址" v-model="mailingAddress" disabled>
                                </el-input>
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <td colspan="2" style="height:22.00pt;">工作单位及详细通信地址</td>
                            <td colspan="8">
                                <el-input placeholder="请输入工作单位及详细通讯地址" v-model="detailedAddress" disabled>
                                </el-input>
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <td colspan="2" style="height:22.00pt;">何时何校何专业毕(结)业</td>
                            <td colspan="8">
                                <el-input placeholder="请输入何时何校何专业毕（结）业" v-model="ex1" disabled>
                                </el-input>
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <td colspan="2" style="height:22.00pt;">何时何地再培训毕(结)业</td>
                            <td colspan="8">
                                <el-input placeholder="请输入何时何地再培训毕（结）业" v-model="ex2" disabled>
                                </el-input>
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <td colspan="2" style="height:22.00pt;"><span style="color: red;">*</span>本人承诺</td>
                            <td colspan="8">
                                <el-input placeholder="本人承诺在XX公司工作X年，XX职位，XX级别" v-model="personalCommitment" disabled>
                                </el-input>
                            </td>
                        </tr>
                        <tr style="height: 192px;">
                            <td style="height:75.00pt;">本人简历</td>
                            <td colspan="9">

                                <div id="userResume-editor" class="edui-default">
                                    <!-- <quill-editor ref="text" v-model="content" class="myQuillEditor" :options="editorOption" /> -->
                                    <div v-html="content"></div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="9" class="serviceAgreement" style="padding-left: 206px;">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </el-dialog>


        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        compoents: {

        },
        data() {
            return {
                state: 0,
                dialogTableVisible2: false,
                total: 0,   //一共多少条
                pagesize: 10,  //一页几条
                currentPage: 1,//当前页
                tableData: [],
                orderId: 0,
                firmlyBelieveCost: 0,
                declareUserId: 0, //当前点击数据申报表id
                tableDataHistory: [],
                editorOption: {
                    modules: {
                        toolbar: [
                            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                            ["blockquote", "code-block"], // 引用  代码块
                            [{ header: 1 }, { header: 2 }], // 1、2 级标题
                            [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
                            [{ script: "sub" }, { script: "super" }], // 上标/下标
                            [{ indent: "-1" }, { indent: "+1" }], // 缩进
                            // [{'direction': 'rtl'}],                         // 文本方向
                            [{ size: ["small", false, "large", "huge"] }], // 字体大小
                            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
                            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
                            [{ font: [] }], // 字体种类
                            [{ align: [] }], // 对齐方式
                            ["clean"], // 清除文本格式
                            ["link", "image", "video"] // 链接、图片、视频
                        ], //工具菜单栏配置
                    },
                    placeholder: '请在这里添加产品描述', //提示
                    readyOnly: false, //是否只读
                    theme: 'snow', //主题 snow/bubble
                    syntax: true, //语法检测
                },
                content: '',
                sex: 1,
                mailOrNot: 1,//证书 是否邮寄 2是 1否
                mailingAddress: '',// 证书邮寄地址
                detailedAddress: '',//工作地址详细通讯地址
                ex1: '',//何时何校何转业 毕业
                ex2: '',//请输入何时何地再培训毕（结）业
                personalCommitment: '',//本人承诺在XX公司工作X年，XX职位，XX级别
                userName: '',
                phoneNumber: '15135086317',
                idCard: '142623199509146119',
                nation: '',
                nationList: ['汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族', '满族'
                    , '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '傈僳族', '佤族', '畲族', '高山族'
                    , '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族'
                    , '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族'
                    , '德昂族', '保安族', '裕固族', '裕固族', '京族', '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'],
                education: '',
                educationList: ['博士', '研究生', '本科', '专科', '高中', '初中', '小学', '其他'],
                politic_countenance: '',
                politic_countenanceList: ['中共党员', '中共预备党员', '共青团员', '民革党员', '民盟盟员', '民建会员', '民进会员'
                    , '农工党党员', '致公党党员', '九三学社社员', '台盟盟员', '无党派人士', '群众', '其他'],
                registrationPlace: '',
                registrationPlaceList: [{ name: '太原', value: '1' }, { name: '大同', value: '2' }, { name: '忻州', value: '3' }
                    , { name: '阳泉', value: '4' }, { name: '吕梁', value: '5' }, { name: '晋中', value: '6' }, { name: '临汾', value: '7' }
                    , { name: '长治', value: '8' }, { name: '晋城', value: '9' }, { name: '运城', value: '10' }, { name: '朔州', value: '11' }],
                candidatesSource: [],
                candidatesSourceList: [
                    {
                        value: '企业职工', label: '企业职工', children: [{ value: '国有企业', label: '国有企业' }, { value: '私营企业', label: '私营企业' }
                            , { value: '个体企业', label: '个体企业' }, { value: '外商投资', label: '外商投资' }, { value: '港澳台商投资', label: '港澳台商投资' }]
                    },
                    {
                        value: '院校学生', label: '院校学生', children: [{ value: '职业高中', label: '职业高中' }, { value: '普通技工学校', label: '普通技工学校' }
                            , { value: '高级技工学校', label: '高级技工学校' }, { value: '技师学院', label: '职业技术学院' }, { value: '普通中专', label: '普通中专' }
                            , { value: '普通高中', label: '普通高中' }, { value: '普通大专', label: '普通大专' }, { value: '普通大学', label: '普通大学' }
                            , { value: '研究生院', label: '研究生院' }, { value: '其他', label: '其他' }]
                    },
                    { value: '社会人员', label: '社会人员', children: [{ value: '社会人员', label: '社会人员' }] },
                    { value: '机关事业单位', label: '机关事业单位', children: [{ value: '机关事业单位', label: '机关事业单位' }] }],
                professionTime: '',//工作时间
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                historyWorkTypeLevel: '',
                historyWorkTypeLevelList: [{ name: '高级技师', value: 1 }, { name: '技师', value: 2 }, { name: '三级（高级工）', value: 3 },
                { name: '四级（中级工）', value: 4 }, { name: '五级（初级工）', value: 5 }],
                professionYears: '',//工种年限
                historyWorkTypeId: 0,
                historyWorkTypeIdList: [],
                certificateNum: '',
                historyWorkTypeDate: '',
                workTypeId: '',
                declareClassification: '',
                declareClassificationList: ['初次鉴定', '晋级鉴定', '补考鉴定'],
                workTypeLevelState: 0
            }
        },
        created() {
            this.state = this.$route.params.state;

            this.workTypeLevelState = this.$route.params.workTypeLevelState
            var params = new URLSearchParams();

            console.log("declare===========" + this.$storage.get('declareUser'));
            params.append('userType', '1');
            params.append('groupType', '1');
            params.append('workTypeGradeOpen', this.$route.params.workTypeLevelState);
            this.$axios.post(this.serverUrl + '/getGroupList', params).then(resp => {

                if (resp.data.code === '4001') {

                    this.$message({
                        showClose: true,
                        message: '请求过于频繁,于一分钟后重试！',
                        type: 'error'
                    })

                } else if (resp.data.code === '4000' || resp.data.code === '4002' || resp.data.code === '4003') {
                    this.$confirm('登录超时！请重新登录').then(_ => {
                        this.$router.push('/login');
                    }).catch(_ => { });
                } else {

                    resp.data.data.forEach(element => {
                        let historyWork = {
                            name: '',
                            value: ''
                        }
                        historyWork.name = element.workTypeName;
                        historyWork.value = element.workTypeId;
                        this.historyWorkTypeIdList.push(historyWork);

                    });
                }


            }).catch(err => {
                this.$message('工种列表加载失败！');
            })


            //当前申报
            this.loadData(this.currentPage, this.pagesize);
            //历史申报
            this.historyLoadData(this.currentPage, this.pagesize);
        },
        mounted() {

        },
        methods: {
            //取消
            affirmCancel(row) {
                this.$confirm('确认删除?', '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {

                    let parames = new URLSearchParams();
                    parames.append('levelState', this.$route.params.workTypeLevelState);
                    parames.append('userId', this.$storage.get('declareUser').id);
                    parames.append('id', row.id);
                    //获取 当前等级下的上传资料 列表
                    this.$axios.post(this.serverUrl + '/cancleDeclareById', parames).then(resp => {
                        if (resp.data.code === 1) {
                            this.$message({
                                message: '恭喜你，删除成功！！',
                                type: 'success'
                            });
                            this.loadData(this.currentPage, this.pagesize);
                        }
                    }).catch(err => {
                    })
                }).catch(() => {

                });
            },
            //导出
            exportDetail(row) {
                let url = this.serverUrl + "/de/exportDeclareMessage?id=" + row.id;
                window.open(url);
            },
            //提交审核
            submitAudit(row) {
                this.$confirm('提交审核之后将不能上传资料，确认提交?', '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    let parames = new URLSearchParams();
                    parames.append('id', row.id);
                    parames.append('declareStatus', 2);
                    this.$axios.post(this.serverUrl + '/updateDeclareUserOcccpationState', parames).then(resp => {
                        if (resp.data.code === 1) {
                            //刷新thatMaterialList数据
                            this.loadData(this.currentPage, this.pagesize);

                            this.$message({
                                message: '恭喜你！提交审核成功！',
                                type: 'success'
                            });
                        } else {
                            this.$message.error('提交审核失败！');
                        }
                    }).catch(err => {
                    })
                }).catch(() => {
                });
            },
            //申报详情
            affirmDetails(row) {
                let parames = new URLSearchParams();
                parames.append('declareUserId', row.id);
                this.$axios.post(this.serverUrl + '/selectDeclareUser', parames).then(resp => {
                    this.userName = resp.data.DeclareUserInfoView.userName;
                    this.sex = resp.data.DeclareUserInfoView.sex;  //性别
                    this.phoneNumber = this.$storage.get('declareUser').telephone;
                    this.nation = resp.data.DeclareUserInfoView.nation; //民族
                    this.idCard = resp.data.DeclareUserInfoView.idCard;
                    this.education = resp.data.DeclareUserInfoView.education; //学历
                    this.politic_countenance = resp.data.DeclareUserInfoView.politic_countenance; //政治面貌
                    this.registrationPlace = resp.data.DeclareUserInfoView.registrationPlace;//报名点所在地
                    let ArrayList = [];
                    ArrayList.push(resp.data.DeclareUserInfoView.candidatesSource);
                    ArrayList.push(resp.data.DeclareUserInfoView.candidatesSourceSon)
                    this.candidatesSource = ArrayList;

                    if (resp.data.DeclareUserInfoView.professionTime != null) {
                        this.professionTime = resp.data.DeclareUserInfoView.professionTime;//参加本职业（工种）时间
                    }
                    this.historyWorkTypeLevel = resp.data.DeclareUserInfoView.historyWorkTypeLevel;//原技术等级
                    this.professionYears = resp.data.DeclareUserInfoView.professionYears;//参加本职业工种年限
                    this.historyWorkTypeId = resp.data.DeclareUserInfoView.historyWorkTypeId;//原职业工种id
                    this.certificateNum = resp.data.DeclareUserInfoView.certificateNum;//原证书编号
                    if (resp.data.DeclareUserInfoView.historyWorkTypeDate != null) {
                        this.historyWorkTypeDate = resp.data.DeclareUserInfoView.historyWorkTypeDate;//原证书取得时间
                    }

                    this.workTypeId = resp.data.DeclareUserInfoView.workTypeId;//认定职业工种id
                    this.declareClassification = resp.data.DeclareUserInfoView.declareClassification;//鉴定分类
                    this.mailOrNot = resp.data.DeclareUserInfoView.mailOrNot; //证书是否需要邮寄 1不邮寄 2 邮寄
                    this.mailingAddress = resp.data.DeclareUserInfoView.mailingAddress; //证书邮寄地址
                    this.detailedAddress = resp.data.DeclareUserInfoView.detailedAddress;//公司所在详细地址
                    resp.data.DeclareUserInfoView.workExperiences.forEach(val => {
                        if (val.exState === 1) {
                            this.ex1 = val.experienceDesc;// 何时何校何专业毕(结)业
                        } else {
                            this.ex2 = val.experienceDesc;// 何时何地再培调毕(结)业
                        }
                    })
                    this.personalCommitment = resp.data.DeclareUserInfoView.personalCommitment;//本人承诺
                    this.content = resp.data.DeclareUserInfoView.userResume;//个人简历
                    this.dialogTableVisible2 = true;
                }).catch(err => {

                })
            },
            //切换每页多少条 触发
            handleSizeChange(val) {
                console.log(`每页dusoaho条`);
                this.pagesize = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            //第几页切换的时 触发
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            getWorkTypeLevelStateDesc(level) {
                var workTypeLevelStateDesc = '';
                switch (level) {
                    case 1:
                        workTypeLevelStateDesc = "高级技师";
                        break; //可选
                    case 2:
                        //语句
                        workTypeLevelStateDesc = "技师";
                        break; //可选
                    case 3:
                        //语句
                        workTypeLevelStateDesc = "三级（高级工）";
                        break; //可选
                    case 4:
                        //语句
                        workTypeLevelStateDesc = "四级（中级工）";
                        break; //可选
                    default: //可选
                        //语句
                        workTypeLevelStateDesc = "五级（初级工）";
                }
                return workTypeLevelStateDesc;
            },
            loadData(page, limit) {
                let parames = new URLSearchParams();
                parames.append('levelState', this.$route.params.workTypeLevelState);
                //parames.append('order_status', 1);
                parames.append('examineStatus', 1);
                parames.append('userId', this.$storage.get('declareUser').id);
                parames.append('page', page);
                parames.append('limit', limit);

                if (this.state == 2) {
                    parames.append('declareCode', this.declareCode);
                }
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/getDeclareUserOccupation_v1', parames).then(resp => {
                    this.total = resp.data.count;
                    if (resp.data.code === 1) {
                        let ArrayList = [];
                        resp.data.data.forEach(element => {
                            let UserDeclareOccupationData = {
                                id: '',//申报主表id
                                workTypeAlias: '',//申报工种名称
                                workTypeLevelState: 0,//申报等级
                                workTypeLevelStateDesc: '',
                                registrationreStatus: 0,
                                workTypeId: 0,
                                scienceSumNum: 0,//当前工种申报等级所需上传认定条件资料总量
                                scienceNum: 0,  //当前工种申报等级下的材料数量-每种条件只能上传一份材料
                                declareStatus: 0,////申报状态  1确定申报  2取消申报  3.申报中 2020年10月23日09:19:08  liqi  新增申报中状态
                                insertTime: '',//资料填写时间
                                declareTime: '',
                                examineStatus: 0,
                                declareClassification: ''
                            };
                            UserDeclareOccupationData.id = element.id;
                            UserDeclareOccupationData.workTypeAlias = element.workTypeAlias;
                            UserDeclareOccupationData.workTypeLevelState = element.workTypeLevelState;
                            UserDeclareOccupationData.workTypeLevelStateDesc = this.getWorkTypeLevelStateDesc(element.workTypeLevelState);
                            UserDeclareOccupationData.declareStatus = element.declareStatus;
                            UserDeclareOccupationData.registrationreStatus = element.registrationreStatus;  //报名状态
                            UserDeclareOccupationData.declareTime = element.declareTime.substring(0, 10); //申报时间
                            UserDeclareOccupationData.examineStatus = element.examineStatus;//审核状态


                            UserDeclareOccupationData.workTypeId = element.workTypeId;

                            UserDeclareOccupationData.declareClassification = element.declareClassification;


                            UserDeclareOccupationData.insertTime = element.insertTime.substring(0, 10);
                            ArrayList.push(UserDeclareOccupationData);
                        });
                        this.tableData = ArrayList;
                    }
                }).catch(err => {
                    console.log(err);
                })
            },
            historyLoadData(page, limit) {
                let parames = new URLSearchParams();
                parames.append('levelState', this.$route.params.workTypeLevelState);
               // parames.append('order_status', 1);
                parames.append('examineStatus', 2);
                parames.append('userId', this.$storage.get('declareUser').id);
                parames.append('page', page);
                parames.append('limit', limit);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/getDeclareUserOccupation_v1', parames).then(resp => {
                    this.total = resp.data.count;
                    if (resp.data.code === 1) {
                        let ArrayList = [];
                        resp.data.data.forEach(element => {
                            let UserDeclareOccupationData = {
                                id: '',//申报主表id
                                workTypeAlias: '',//申报工种名称
                                workTypeLevelState: 0,//申报等级
                                workTypeLevelStateDesc: '',
                                registrationreStatus: 0,
                                workTypeId: 0,
                                scienceSumNum: 0,//当前工种申报等级所需上传认定条件资料总量
                                scienceNum: 0,  //当前工种申报等级下的材料数量-每种条件只能上传一份材料
                                declareStatus: 0,////申报状态  1确定申报  2取消申报  3.申报中 2020年10月23日09:19:08  liqi  新增申报中状态
                                insertTime: '',//资料填写时间
                                declareTime: '',
                                examineStatus: 0,
                                declareClassification: ''
                            };
                            UserDeclareOccupationData.id = element.id;
                            UserDeclareOccupationData.workTypeAlias = element.workTypeAlias;
                            UserDeclareOccupationData.workTypeLevelState = element.workTypeLevelState;
                            UserDeclareOccupationData.workTypeLevelStateDesc = this.getWorkTypeLevelStateDesc(element.workTypeLevelState);
                            UserDeclareOccupationData.declareStatus = element.declareStatus;
                            UserDeclareOccupationData.registrationreStatus = element.registrationreStatus;  //报名状态
                            UserDeclareOccupationData.declareTime = element.declareTime.substring(0, 10); //申报时间
                            UserDeclareOccupationData.examineStatus = element.examineStatus;//审核状态
                            UserDeclareOccupationData.workTypeId = element.workTypeId;
                            UserDeclareOccupationData.declareClassification = element.declareClassification;
                            UserDeclareOccupationData.insertTime = element.insertTime.substring(0, 10);
                            ArrayList.push(UserDeclareOccupationData);
                        });
                        this.tableDataHistory = ArrayList;
                    }
                }).catch(err => {
                    console.log(err);
                })
            }
        }
    }
</script>

<style scoped>
    .el-table__empty-block {
        min-height: 60px;
        text-align: center;
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .el-dialog {
        position: relative;
        margin: 0 auto 50px;
        border-radius: 2px;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
        box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 80%;
        height: 650px;
        overflow: scroll;
        margin-top: 5vh !important;
    }

    .el-dialog--center .el-dialog__body {
        text-align: initial;
        /* padding: 25px 25px 30px; */
    }

    .el-dialog__body {
        padding: 0 !important;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }


    #toBuy {
        width: 140px;
        line-height: 38px;
        color: #fff;
        font-size: 16px;
        border-radius: 2px;
        background: #5FB878;
        border: none;
        cursor: pointer;
    }

    .zhifu {
        float: right;
        margin-top: 22px;
        margin-right: 23px;
    }

    .allPrice {
        float: left;
        font-size: 18px;
        color: red;
        margin-top: 27px;
        margin-left: 40px;
    }

    .order_bottom {
        width: 100%;
        height: 79px;
        background-color: white;
        position: absolute;
        bottom: 0px;
        left: 0;
        box-shadow: 0px 2px 6px #ccc;
    }

    .open_right {
        width: 500px;
        margin-top: 31px;
        float: left;
    }

    #ddBox {
        padding-left: 24px;
        padding-right: 24px;
        padding-bottom: 80px;
        height: 226px;
        overflow-y: auto;
    }

    .open_left {
        float: left;
        margin-top: 19px;
        width: 115px;
        line-height: 60px;
        text-align: right;
        font-size: 14px;
        color: #000000;
        padding-right: 28px;
        box-sizing: border-box;
    }

    .el-radio__input.is-checked+.el-radio__label {
        color: #5FB878;
    }

    .el-radio__input.is-checked .el-radio__inner {
        border-color: #5FB878;
        background: #5FB878;
    }

    select {
        display: none;
    }

    .layui-edge {
        display: inline-block;
        width: 0;
        height: 0;
        border-width: 6px;
        border-style: dashed;
        border-color: transparent;
    }

    .layui-form-select .layui-edge {
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -3px;
        cursor: pointer;
        border-width: 6px;
        border-top-color: #c2c2c2;
        border-top-style: solid;
        transition: all .3s;
        -webkit-transition: all .3s;
    }

    .layui-form-select dl dd,
    .layui-form-select dl dt {
        padding: 0 10px;
        line-height: 36px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .layui-form-select dl dd {
        cursor: pointer;
    }

    .layui-form-select dl dd.layui-this {
        background-color: #5FB878;
        color: #fff;
    }

    .layui-form-select dl dd.layui-select-tips {
        padding-left: 10px !important;
        color: #999;
    }

    dl {
        display: none;
        position: absolute;
        left: 0;
        top: 42px;
        padding: 5px 0;
        z-index: 899;
        min-width: 100%;
        border: 1px solid #d2d2d2;
        max-height: 300px;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
        box-sizing: border-box;
    }

    .layui-input,
    .layui-textarea {
        display: block;
        width: 100%;
        padding-left: 10px;
        height: 38px;
        line-height: 1.3;
        line-height: 38px\9;
        border-width: 1px;
        border-style: solid;
        background-color: #fff;
        border-radius: 2px;
    }

    .layui-form-select .layui-input {
        padding-right: 30px;
        cursor: pointer;
    }

    .layui-form-label,
    .layui-form-mid,
    .layui-form-select,
    .layui-input-block,
    .layui-input-inline,
    .layui-textarea {
        position: relative;
    }

    .layui-input-inline {
        display: inline-block;
        vertical-align: middle;
    }

    button,
    input,
    optgroup,
    option,
    select,
    textarea {
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        font-weight: inherit;
        outline: 0;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .layui-btn-normal {
        background-color: #1E9FFF;
    }

    .layui-btn-sm {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        font-size: 12px;
    }

    .layui-anim.layui-icon {
        display: inline-block;
    }

    .layui-form-radio>i {
        margin-right: 8px;
        font-size: 22px;
        color: #c2c2c2;
    }

    .layui-form-radio {
        display: inline-block;
        vertical-align: middle;
        line-height: 28px;
        margin: 6px 10px 0 0;
        padding-right: 10px;
        cursor: pointer;
        font-size: 0;
    }

    .layui-input-block {
        margin-left: 110px;
        min-height: 36px;
    }

    .ux-input_base {
        padding: .16rem .32rem;
        font-size: 14px;
        border: 1px solid #ddd;
        color: #555;
        background: #fff;
        border-radius: 2px;
        vertical-align: middle;
    }

    .ux-input2,
    .ux-textarea2 {
        display: inline-block;
        position: relative;
        white-space: nowrap;
    }

    .userInfo .layui-icon-tips {
        font-size: 13px;
    }

    .layui-show {
        display: block !important;
    }

    .layui-upload-drag .layui-icon {
        font-size: 50px;
        color: #009688;
    }

    .layui-upload-file {
        display: none !important;
        opacity: .01;
        filter: Alpha(opacity=1);
    }

    .layui-upload-drag {
        position: relative;
        padding: 30px;
        border: 1px dashed #e2e2e2;
        background-color: #fff;
        text-align: center;
        cursor: pointer;
        color: #999;
    }

    .layui-upload-drag {
        border: 1px solid #5fb878;
    }

    .layui-icon {
        font-family: layui-icon !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .userInfo .layui-icon-tips {
        font-size: 13px;
    }

    .input-row-right input[type="text"] {
        width: 400px;
        height: 30px;
    }

    .ux-input2,
    .ux-textarea2 {
        display: inline-block;
        position: relative;
        white-space: nowrap;
    }

    .profile-image-upload {
        text-align: center;
        position: relative;
        vertical-align: top;
        display: inline-block;
        border-radius: 50%;
        width: 104px;
        height: 104px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url(/jnrd/img/profile-image.png);
    }

    .input-row-right {
        font-size: 12px;
        width: 690px;
        text-align: left;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .input-row-left {
        width: 100px;
        text-align: left;
        padding-left: 50px;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .f-cb:after {
        display: block;
        clear: both;
        visibility: hidden;
        height: 0;
        overflow: hidden;
        content: ".";
    }

    .layui-card-body {
        position: relative;
        padding: 10px 15px;
        line-height: 24px;
    }

    .layui-card-header {
        position: relative;
        height: 42px;
        line-height: 42px;
        padding: 0 15px;
        border-bottom: 1px solid #f6f6f6;
        color: #333;
        border-radius: 2px 2px 0 0;
        font-size: 14px;
    }

    .u-gx-ttop {
        border-bottom: none;
        margin: 0 15px;
        height: 38px;
        padding: 10px 0;
    }

    .f-fc9 {
        color: #999;
    }

    .f-f0 {
        font-family: "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
    }

    .f-fl {
        float: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/affirm/affirmrecord.vue